// Copyright (c) 2017 Deere & Company

import PartialDebitModal from './partial-debit-modal-container';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    busyCounter: state.tcsm.partialDebit.busyCounter,
    debit: state.tcsm.partialDebit.debit,
    isEditable: false,
    isPartialDebitModalVisible: state.tcsm.partialDebit.isPartialDebitModalVisible
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps
    },
    queryParams: parentProps.queryParams,
    routeParams: parentProps.routeParams
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(PartialDebitModal);



// WEBPACK FOOTER //
// ./src/tcsm/partial-debit/components/partial-debit-modal/index.js